import { render, staticRenderFns } from "./DialogPrice.vue?vue&type=template&id=5149ac35&scoped=true&"
import script from "./DialogPrice.vue?vue&type=script&lang=js&"
export * from "./DialogPrice.vue?vue&type=script&lang=js&"
import style0 from "./DialogPrice.vue?vue&type=style&index=0&id=5149ac35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5149ac35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDialog,VIcon,VRow,VTextField})
